<ul class="divide-y divide-ui-gray-light border-t border-t-ui-gray-light">
  @for (rule of displayRules(); track rule.id) {
    <li class="flex items-center justify-between px-5 pl-20 h-[44px] text-sm text-ui-dark bg-white">
      <span>
        @if (rule.name) {
          <strong>{{ rule.name }}</strong>
          |
        }
        {{ rule.code }} {{ rule.operator }} {{ rule.conditionValue }} {{ rule.durationLabel }}
      </span>
      <div
        class="flex items-center"
        avsRestrictedEl
      >
        @if (hasCoordinates(rule)) {
          <button
            class="btn-white-stroked hover:text-white hover:bg-ui-blue-100 active:bg-ui-blue-150 btn-small mr-2"
            (click)="assignRule(rule.id)"
            [class]="activeAttachmentId() === rule.id ? 'bg-ui-blue-150 text-white' : ''"
            [disabled]="defaultDocumentTab === documentTab() || !documentTab()"
          >
            <i class="icon-move text-3xl mr-1"></i>
            Move/Resize
          </button>
          <button
            class="btn-white-stroked btn-small hover:bg-ui-red-50 hover:text-white active:bg-ui-red-150"
            (click)="unassignRule(rule)"
          >
            <i class="icon-Unassign text-3xl mr-1"></i>
            Unassign
          </button>
        } @else {
          <button
            class="btn-blue btn-small"
            (click)="assignRule(rule.id)"
            [class.bg-ui-blue-150]="activeAttachmentId() === rule.id"
            [disabled]="defaultDocumentTab === documentTab() || !documentTab()"
          >
            <i class="icon-Assign-a-Room text-3xl mr-1"></i>
            Assign rule
          </button>
        }
      </div>
    </li>
  } @empty {
    <li class="px-3 py-2 text-xs text-ui-gray-100 italic">No incident rules found</li>
  }
</ul>
